import * as React from "react";

const HelpCircle: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 13" fill="currentColor"><path fill="currentColor" d="M6 12.5a6 6 0 1 0 0-12 6 6 0 1 0 0 12ZM3.937 4.812c0-.724.589-1.312 1.313-1.312h1.334a1.479 1.479 0 0 1 .736 2.763l-.758.434v.553H5.438V6.045l.284-.161 1.038-.596a.354.354 0 0 0-.175-.66H5.25a.188.188 0 0 0-.188.187v.152H3.938v-.154Zm1.5 4.313V8h1.125v1.125H5.438Z"/></svg>;
};

export default React.memo(HelpCircle);
